import store2 from 'store2';
import _ from 'lodash';

const byoStore = store2.namespace('byo');

export const CONFIG = 'config';
export const ORIGIN_URL = 'originUrl';
export const MOBILE_URL = 'mobileUrl';
export const PROGRESS = 'progress';
export const NAV_ITEM_COUNT = 'navItemCount';
export const PROGRESS_ARRAY = 'progressArray';
export const BODY_STYLE_TITLE = 'bodyStyleTitle';

export const getAllByBrandAndCountry = (brand, country) => {
  const storeByBrandAndCountry = store2.namespace(`byo.${country}.${brand}`);

  return Object.keys(storeByBrandAndCountry.getAll())
    .filter(key => _.endsWith(key, `.${CONFIG}`))
    .map(key => key.replace(`.${CONFIG}`, ''))
    .map(key => {
      const config = storeByBrandAndCountry.get(`${key}.${CONFIG}`);
      const originUrl = storeByBrandAndCountry.get(`${key}.${ORIGIN_URL}`);
      const mobileUrl = storeByBrandAndCountry.get(`${key}.${MOBILE_URL}`);
      const progress = storeByBrandAndCountry.get(`${key}.${PROGRESS}`);
      return _.assign({}, config, {
        originUrl,
        mobileUrl,
        progress
      });
    });
};

const buildModelKey = model => {
  const { country, brand, year, carline, bodyStyle } = model;
  return `${country}.${brand}.${carline}.${year}.${bodyStyle}`;
};

const buildFullKey = (model, key) => `${buildModelKey(model)}.${key}`;

export const remove = (modelInfo, key) => {
  byoStore.remove(buildFullKey(modelInfo, key));
};

export const getByModelAndKey = (modelInfo, key) => {
  return byoStore.get(buildFullKey(modelInfo, key));
};

export const setByModelAndKey = (modelInfo, key, data) => {
  return byoStore.set(buildFullKey(modelInfo, key), data, true);
};

export const clearAllByModel = model => {
  const key = buildModelKey(model);
  const modelStore = byoStore.namespace(key);
  // modelStore.clear() is not clearing all subkeys out, iterating over instead
  modelStore.keys().forEach(key => {
    modelStore.remove(key);
  });
};
